<template>
  <div>
    <div v-if="loading" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else>
      <div v-if="products.length === 0" class="text-center text-muted py-4">
        此分類下沒有產品
      </div>
      <draggable
        v-else
        v-model="products"
        item-key="id"
        handle=".drag-handle"
        class="list-group"
        ghost-class="ghost"
      >
        <template #item="{ element }">
          <div
            class="list-group-item d-flex align-items-center justify-content-between p-2 mb-2 border rounded"
          >
            <div class="d-flex align-items-center">
              <i
                class="fas fa-bars drag-handle me-3 text-secondary"
                style="cursor: move"
              ></i>
              <img
                :src="element.image_url || '/no-image.png'"
                class="avatar avatar-sm me-3"
                style="object-fit: cover"
              />
              <div>
                <h6 class="mb-0 text-sm text-truncate" style="max-width: 300px">
                  {{ element.name }}
                </h6>
                <small class="text-muted">{{ element.product_code }}</small>
              </div>
            </div>
            <span class="badge bg-secondary">{{ element.status }}</span>
          </div>
        </template>
      </draggable>

      <div class="d-flex justify-content-end mt-4">
        <button class="btn btn-secondary me-2" @click="$emit('close')">
          取消
        </button>
        <button class="btn btn-primary" @click="saveOrder" :disabled="saving">
          <span
            v-if="saving"
            class="spinner-border spinner-border-sm me-1"
          ></span>
          儲存順序
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import request from "@/utils/request";
import Swal from "sweetalert2";

export default {
  name: "CategoryProductSorter",
  components: {
    draggable,
  },
  props: {
    categoryId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      products: [],
      loading: false,
      saving: false,
    };
  },
  mounted() {
    this.fetchProducts();
  },
  methods: {
    async fetchProducts() {
      this.loading = true;
      try {
        // Fetch specific categories products, asking for a large page size to get all
        const response = await request.get("/api/admin/products", {
          params: {
            category_id: this.categoryId,
            per_page: 500, // Assuming < 500 items per category
          },
        });
        this.products = response.data.data;
      } catch (error) {
        console.error("Failed to fetch products", error);
        Swal.fire("錯誤", "無法載入產品列表", "error");
      } finally {
        this.loading = false;
      }
    },
    async saveOrder() {
      this.saving = true;
      try {
        const productIds = this.products.map((p) => p.id);
        await request.post(
          `/api/admin/categories/${this.categoryId}/reorder-products`,
          {
            products: productIds,
          }
        );

        Swal.fire({
          icon: "success",
          title: "儲存成功",
          text: "產品順序已更新",
          timer: 1500,
          showConfirmButton: false,
        });

        this.$emit("saved");
        this.$emit("close");
      } catch (error) {
        console.error("Failed to save order", error);
        Swal.fire("錯誤", "儲存失敗", "error");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.drag-handle {
  cursor: grab;
}
</style>
